// extracted by mini-css-extract-plugin
module.exports = {"deltamini":"deltamininew_deltamini__aLEme"};